import { c as _c } from "react/compiler-runtime";
import { format } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import { useEffect } from 'react';
import { usePianoProfileState } from '@/hooks/store/use-piano-profile-store';
import { usePrintDate } from '@/hooks/use-print-date';
import { useTranslation } from '@/hooks/use-translation';
import { printMarginsRule } from '@/lib/print/print-margins';

/**
 * Which piano, when, and which page, in the bottom margin of every printed
 * sheet.
 *
 * Renders nothing: the margin of a sheet is out of reach of the document, so
 * the words are handed to `@page` instead, for as long as a page is mounted.
 */
export const PrintMargins = () => {
  const $ = _c(7);
  const {
    currentLanguage,
    t
  } = useTranslation();
  const {
    displayName,
    serialNumber
  } = usePianoProfileState();
  const printDate = usePrintDate();
  let t0;
  let t1;
  if ($[0] !== currentLanguage || $[1] !== displayName || $[2] !== printDate || $[3] !== serialNumber || $[4] !== t) {
    t0 = () => {
      const identity = ["Piano Touch Lab", displayName, serialNumber ? t("S/N {{serialNumber}}", {
        ns: "navigation",
        serialNumber
      }) : null, t("Printed on {{date}}", {
        date: format(printDate, "d MMMM yyyy", {
          locale: currentLanguage.startsWith("fr") ? fr : enUS
        })
      })].filter(Boolean).join(" \xB7 ");
      const style = document.createElement("style");
      style.media = "print";
      style.textContent = printMarginsRule({
        identity,
        pageLabel: t("page")
      });
      document.head.append(style);
      return () => {
        style.remove();
      };
    };
    t1 = [currentLanguage, displayName, printDate, serialNumber, t];
    $[0] = currentLanguage;
    $[1] = displayName;
    $[2] = printDate;
    $[3] = serialNumber;
    $[4] = t;
    $[5] = t0;
    $[6] = t1;
  } else {
    t0 = $[5];
    t1 = $[6];
  }
  useEffect(t0, t1);
  return null;
};